module.exports = __webpack_public_path__ + "media/swiper-button.26419a35.mp4";